import * as React from 'react'
import { IconSeekers, ButtonSeeker } from "ui-seeker/core"
import OutsideAlerter from "./useOutsider"

export default function ModalNewAlert(props) {

    const {open, adults, kids, setAdults, setKids} = props

    const incrementCountAdults = () => setAdults(adults + 1)
    const decrementCountAdults = () => setAdults(adults - 1)

    const incrementCountKids = () => setKids(kids + 1)
    const decrementCountKids = () => setKids(kids - 1)

    return open && <OutsideAlerter {...props}>
        <div className="container-target">
            <div id="target-1">
                <div className="container-selector">
                    <div className="occupancy-row">
                        <div className="title">
                            <p className="label">Adults</p>
                        </div>
                        <div className="input">
                            <ButtonSeeker className="occupation" onClick={decrementCountAdults} disabled={adults === 1}>
                                <IconSeekers icon="minus" iconType="fontAwesome" />
                            </ButtonSeeker>
                            <div className="number dim">{adults}</div>
                            <ButtonSeeker className="occupation" onClick={incrementCountAdults}>
                                <IconSeekers icon="plus" iconType="fontAwesome" />
                            </ButtonSeeker>
                        </div>
                    </div>
                    <div className="occupancy-row">
                        <div className="title">
                            <p className="label">Kids</p>
                        </div>
                        <div className="input">
                            <ButtonSeeker className="occupation" onClick={decrementCountKids} disabled={kids === 0}>
                                <IconSeekers icon="minus" iconType="fontAwesome" />
                            </ButtonSeeker>  
                            <div className="number dim">{kids}</div>
                            <ButtonSeeker className="occupation" onClick={incrementCountKids}>
                                <IconSeekers icon="plus" iconType="fontAwesome" />
                            </ButtonSeeker>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </OutsideAlerter>
}